// RECETTE API BASE URL
// var baseUrl = 'https://api-recette.diekkes.com';

// PRODUCTION API BASE URL
var baseUrl = "https://www.back.django.diekkes.com";

export default baseUrl;
